import { Navigate, Outlet } from "react-router-dom";
import { useProfile } from "../../features/auth/hooks/useProfile";

const GuestRoute = () => {
  const { isNewUser, isUserLogout, isAuthenticated } = useProfile();

  if (isUserLogout) return <Outlet />;

  if (isAuthenticated) {
    if (isNewUser) {
      return <Navigate to="/create-account" replace />;
    }

    return <Navigate to="/locker-room" replace />;
  }

  return <Outlet />;
};

export default GuestRoute;
